import { Tag, ITagProps } from '@blueprintjs/core'
import React from 'react'
import { ITicketDetails } from '@api'

interface LocationTagProps {
  ticket: ITicketDetails
  tagProps?: ITagProps
}

export default function LocationTag({ ticket, tagProps }: LocationTagProps) {
  if (!ticket.building) {
    return null
  }

  return (
    <Tag minimal round {...tagProps}>
      {ticket.building.name} {ticket.floor_plan ? ticket.floor_plan.name : ''}
    </Tag>
  )
}
